import React, { useState, useEffect } from "react";
import Loader from "react-spinner-loader";

// Component
import SearchForm from "../../../../component/search-form";
import { sanitizeInput } from "../../../../utils";
import Table, { TableRow } from "../../../../component/table";
import useDebounce from "../../../../Hook/useDebounce";
import AddCollaborator from "../../collaborators/addCollaborator";
import EditCollaborator from "../../collaborators/editCollaborator";
import DeleteUser from "./deleteUser";
import RowsPerPageSelector from "../../../../component/RowsPerPageSelector";
import PageSelector from "../../../../component/PageSelector";
import Select, { components } from "react-select";

// Redux
import { getCollaboratorOrCustomerListForDataTable } from "../../../../redux/actions/collaboratorOrCustomer";
import { getTimeZoneForOnboarding } from "../../../../redux/actions/onboarding";
import { useSelector, useDispatch } from "react-redux";
import {
  GET_COLLABORATOR_OR_CUSTOMER,
  GET_COLLABORATOR_DETAILS,
} from "../../../../redux/constants";
import { getStakeholderList } from "../../../../redux/actions/stakeholder";

function CollaboratorTable() {
  const rowsPerPage = 10; 
  // State
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState();
  const [update, setUpdate] = useState(1);
  const [tableLoader, setTableLoader] = useState(false);
  const [sort, setSort] = useState();
  const [showcollaboratormodal, setShowCollaboratorModal] = useState(false);
  const [editCollaborator, setEditCollaborator] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [collaboratorId, setCollaboratoId] = useState();
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [ stakeholderOptions, setStakeholderOptions] = useState([]);
  const [selectedStakeholder, setSelectedStakeholder] = useState([]);

  // Redux
  const dispatch = useDispatch();
  const { customerOrCollaboratorList, collaboratorDetail } = useSelector(
    (state) => state.collaboratorOrCustomer
  );
  const { row_count } = useSelector((state) => state.auth);

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  // useEffect to get Collaborator Data
  useEffect(() => {
    setTableLoader(true);
    const request = {
      onError: () => {},
    };
    dispatch(getTimeZoneForOnboarding(request));
    dispatch(
      getCollaboratorOrCustomerListForDataTable(
        "collaborator",
        debouncedHandleSearch,
        page,
        row_count,
        sortField,
        sortOrder,
        selectedStakeholder,
        (res) => {
          setTableLoader(false);
        }
      )
    );
  }, [update, debouncedHandleSearch, page, row_count, sortField, sortOrder, selectedStakeholder]);

  /*--------- Sorting Collaborator ------------ */
  useEffect(() => {
    if (sort) {
      setPage(1);
      setSortField(sort.headName);
      setSortOrder(sort.type);
    }
  }, [sort]);

  useEffect(() => {
    const request = {
      onSuccess: (res) => {
        if(res.status){
          let stakeholders = [];
          res?.data?.data?.forEach( item => {
            stakeholders.push({
              value: item.stakeholder_category_id,
              label: item.stakeholder_category_name,
            })
          });
          setStakeholderOptions(stakeholders);
        }
      },
      onError: () => {}
    }
    dispatch(getStakeholderList(request))
  }, []);

  const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      background: "#d4eefa",
      borderRadius: "4px",
      fontFamily: "Open Sans",
      fontSize: "11px",
      padding: "3px",
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+${length}`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 1;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  return (
    <div className="">
      <div className="flex-auto space-y-2 md:space-y-0 md:flex md:justify-between md:item-center py-3">
        <SearchForm
          placeholder="Search"
          onChange={(e) => {
            const value = sanitizeInput(e.target.value);
            setSearchText(value);
          }}
          value={searchText}
        />
        <div className="md:grow space-x-2 flex items-center justify-end">
          <Select
            options={stakeholderOptions}
            isClearable={true}
            menuPortalTarget={document.body}
            className="basic-single text-sm unresetText"
            classNames={{
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]/50"
                    : "!border-slate-200 hover:!border-gray-300"
                }`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            name="dependent_todo_custom_field_value"
            value={selectedStakeholder}
            onChange={(e) => setSelectedStakeholder(e)}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: "#9B9B9B",
                fontSize: "14px",
              }),
            }}
            placeholder="Select Stakeholder"
            menuPlacement="auto"
            isMulti
            components={{
              MultiValue,
            }}
          />

          <button
            className="btn bg-[--bg-color-500] text-white"
            onClick={() => {
              setShowCollaboratorModal(true);
            }}
          >
            <span className={`fas fa-plus mr-2`}></span>Create Collaborators
          </button>
        </div>
      </div>
      <div>
        <Table
          heads={[
            {
              headName: "Collaborator Name",
              isSort: true,
              value: "name",
            },
            { headName: "Email ID", isSort: true, value: "email" },
            {
              headName: "Stakeholder", isSort: false, value: "stakeholder" 
            },
            { headName: "Action", isSort: false, value: "Action" },
          ]}
          tClass="table-fixed w-full border-separate border-spacing-y-2"
          hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-100]"
          bClass="text-sm"
          thClass={`px-2 py-3 whitespace-nowrap first:text-left text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
          setSort={setSort}
          sort={sort}
        >
          {tableLoader ? (
            <tr className="px-2 py-3 whitespace-nowrap">
              <td colSpan={3}>
                <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                  <Loader show={tableLoader} />
                </div>
              </td>
            </tr>
          ) : customerOrCollaboratorList?.data?.length > 0 ? (
            customerOrCollaboratorList.data.map((collabItem, index) => {
              const { name, email, stakeholder_category_mappings } = collabItem;
              const stakeholder = stakeholder_category_mappings.map(item => item.stakeholder_category_name).join(", ");
              return (
                <TableRow
                  key={index}
                  row={{
                    name,
                    email,
                    stakeholder
                  }}
                  tdClass="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-center first:text-left bg-[--bg-color-50] rounded-l-md max-w-1/4 truncate"
                >
                  <td className="px-2 py-2 whitespace-nowrap text-center text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold">
                    <div className="space-x-3 flex items-center justify-center">
                      <div title="Edit">
                        <span
                          className="fa-light fa-pen text-base cursor-pointer"
                          style={{ color: "#9297a2" }}
                          onClick={() => {
                            dispatch({
                              type: GET_COLLABORATOR_DETAILS,
                              payload: collabItem,
                            });
                            setEditCollaborator(true);
                          }}
                        ></span>
                      </div>
                      <div title="Delete">
                        <span
                          className="fa-light fa-trash-can text-base cursor-pointer"
                          style={{ color: "#eb5757" }}
                          onClick={() => {
                            setOpenDeleteModal(true);
                            setCollaboratoId(collabItem.collaborator_id);
                          }}
                        ></span>
                      </div>
                    </div>
                  </td>
                </TableRow>
              );
            })
          ) : (
            <td
              colSpan={3}
              className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
            >
              There are no records to display
            </td>
          )}
        </Table>
        {!tableLoader && customerOrCollaboratorList?.data?.length > 0 && (
          <div className="flex justify-between items-center">
            <RowsPerPageSelector />
            <PageSelector
              rowPerPage={row_count}
              page={page}
              setpage={(newPage) => {
                setPage(newPage);
              }}
              totalDataCount={
                customerOrCollaboratorList
                  ? customerOrCollaboratorList.totalCount
                  : 0
              }
            />
          </div>
        )}
      </div>

      <AddCollaborator
        id="add-collaborator"
        modalOpen={showcollaboratormodal}
        setModalOpen={setShowCollaboratorModal}
        update={update}
        setUpdate={setUpdate}
      />

      <EditCollaborator
        collaboratorDetail={collaboratorDetail}
        searchId="edit-collab"
        modalOpen={editCollaborator}
        setModalOpen={setEditCollaborator}
        update={update}
        setUpdate={setUpdate}
      />

      <DeleteUser
        type="Collaborator"
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        update={update}
        setUpdate={setUpdate}
        setUserId={setCollaboratoId}
        userId={collaboratorId}
      />
    </div>
  );
}

export default CollaboratorTable;
